import type { Enum } from './generics';

export const Application = {
  MyWork: 'workApp',
  MyLocation: 'locationApp',
  MyGroup: 'groupApp',
} as const;

export type ApplicationType = Enum<typeof Application>;
